export default __webpack_public_path__ + "static/breakpoint-setting-do-light-6391b7350120ed7c1974647f329b7f0e13bf840fb6903824e8e6a501df3d2a24.png";